var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"play-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}},[_c('polygon',{attrs:{"points":"8 5 19 12 8 19 8 5","fill":_vm.color,"x":"6","y":"6","width":"12","height":"12"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }